import React from 'react';
import styles from './Maintenance.module.css';
import CountdownTimer from '../../components/CountdownTimer/CountdownTimer';
import ComingBackSoon from './ComingBackSoon';
import Footer from '../../components/Footer/Footer';
import ContactUs from './ContactUs';
import { createDateInET } from '../../utils/dateUtils';

// January 5, 2026 at 9:00 AM ET
const LAUNCH_DATE = createDateInET(2026, 1, 5, 9);

const Maintenance = () => (
  <div className={styles.container}>
    <div className={styles.content}> 
      <div className={styles.header}>
        <img src={`${process.env.PUBLIC_URL}/assets/logo-header-color.svg`} alt="logo" />
      </div>
      <div className={styles.body}>
        <ComingBackSoon />
        <CountdownTimer endDate={LAUNCH_DATE} hideWhenPast />
        <ContactUs />
      </div>
    </div>
    <Footer />
  </div>
);

export default Maintenance;

